import { PhotoIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";

function NoRenderings() {
  const { t } = useTranslation();

  return (
    <div className="text-center">
      <PhotoIcon className="mx-auto h-6 w-6 text-gray-500" aria-hidden="true" />
      <h3 className="mt-2 text-sm font-semibold text-gray-900">
        {t("renderings_empty_title")}
      </h3>
      <p className="mt-1 text-sm text-gray-500">
        {t("renderings_empty_body")}
      </p>
    </div>
  );
}

export default NoRenderings;
